import { TGoogleRegisterRequest } from "@/features/auth/types/google-register";
import { TApiRes } from "@/types/api";
import { clientApi } from "@/utils/api";

export const googleRegisterApi = async (payload: TGoogleRegisterRequest): Promise<boolean> => {
  try {
    const {
      data: { data },
    } = await clientApi.post<TApiRes<boolean>>("/register-google", payload);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
